// In-memory fallback for company params: iOS Safari (private/ITP) can silently
// drop localStorage writes mid-session, which would blank out every API request.
const MIRRORED_KEYS = ['guid', 'registerId', 'dataEnc']
const memoryStore: { [key: string]: any } = {}
let storageWarned = false

const readRaw = (key: string): string | null => {
  try {
    return window?.localStorage?.getItem(key) ?? null
  } catch {
    return null
  }
}

const mirrorFallback = (key: string) =>
  MIRRORED_KEYS.includes(key) ? memoryStore[key] ?? null : null

export const handleLocalStorage = (
  values: string | string[] | { [key: string]: any }
) => {
  if (typeof values === 'string') {
    const value = readRaw(values)
    if (value && value !== 'undefined' && value.trim() !== '') {
      try {
        return JSON.parse(value)
      } catch {
        return value
      }
    }
    return mirrorFallback(values)
  }
  if (Array.isArray(values)) {
    const result: any = {}
    values.map((value) => {
      const item = readRaw(value)
      if (item && item !== 'undefined' && item.trim() !== '') {
        try {
          result[value] = JSON.parse(item)
        } catch {
          result[value] = item
        }
      } else {
        result[value] = mirrorFallback(value)
      }
    })
    return result
  }
  if (typeof values === 'object') {
    Object.keys(values).map((value) => {
      if (MIRRORED_KEYS.includes(value) && values[value] != null) {
        memoryStore[value] = values[value]
      }
      try {
        window.localStorage.setItem(value, JSON.stringify(values[value]))
      } catch (e) {
        // setItem can throw on iOS (private/blocked storage); mirror covers reads.
        if (!storageWarned) {
          storageWarned = true
          console.warn(
            'localStorage unavailable — using in-memory company-param fallback',
            e
          )
        }
      }
    })
    return values
  }
}
